import { types } from 'mobx-state-tree';

const ListingOptions = types
  .model('ListingOptions', {
    enableSalesTax: types.optional(types.boolean, true),
    defaultHtmlTemplateId: types.optional(types.string, ''),
    maximalShippingTime: types.optional(types.number, 0),
    minimalQuantityInStock: types.optional(types.number, 0),
    defaultQuantityToList: types.optional(types.number, 0),
    sourceMarketplaceId: types.optional(types.string, ''),
    destinationMarketplaceId: types.optional(types.string, ''),
    country: types.maybe(types.string),
    postalCode: types.maybe(types.string),
    cityState: types.maybe(types.string),
  })
  .views(self => ({
    get isDefault() {
      const {
        enableSalesTax,
        defaultHtmlTemplateId,
        maximalShippingTime,
        minimalQuantityInStock,
        defaultQuantityToList,
        sourceMarketplaceId,
        destinationMarketplaceId,
        country,
        postalCode,
        cityState,
      } = self;
      return (
        enableSalesTax === true &&
        defaultHtmlTemplateId === '' &&
        maximalShippingTime === 0 &&
        minimalQuantityInStock === 0 &&
        defaultQuantityToList === 0 &&
        sourceMarketplaceId === '' &&
        destinationMarketplaceId === '' &&
        country === null &&
        postalCode === null &&
        cityState === null
      );
    },
  }));

export default ListingOptions;
